import styled from '@emotion/styled'
import ReactQuill from 'react-quill'
export const StyleReactQuill = styled(ReactQuill)<any>`
  .ql-editor {
    height: 300px;
    max-height: 300px;
    overflow: auto;
  }
  .ql-toolbar.ql-snow {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`
